<template>
  <div>
    <!-- Soccer Chalkboard / Goal -->
    <div class="chalkboard-goal">
      <div class="is-bordered-box-shadow-main">
        <SoccerChalkboard
          analysis-type="defensive"
          section-type="player"
          :plays="chalkboardPlays"
          :categories="translatedDefensiveCategories"
          :games="chalkboardGames"
          :players="[{ ...player, jersey: player.jersey_number }]"
          :team="player.team_id"
          :playValuesIndex="playerStatsPlayIndexes"
          @changePerspective="onChangePerspectiveSoccerChalkboard"
          @changeSelectAll="onChangeSelectAllSoccerChalkboard"
          @changeCategory="onChangeCategorySoccerChalkboard"
        />
      </div>
      <div>
        <SoccerGoal
          v-if="showSoccerGoal"
          :players="[player]"
          section-type="player"
          type="defensive"
          :plays="goalPlays"
          :teams="seasonTeams"
          @changeCategory="onChangeCategorySoccerGoal"
        />
      </div>
    </div>
    <!-- Timeline -->
    <!--    <div class="columns">-->
    <!--      <div class="column"></div>-->
    <!--    </div>-->
    <!-- Top Five Categories -->
    <!--    <div class="top-five-container">-->
    <!--      <div class="top-five-title">-->
    <!--        categorias dentro de top 5-->
    <!--      </div>-->
    <!--      <TopFiveHorizontalScroll :categories="topFiveCategories" />-->
    <!--    </div>-->
    <!-- Player Categories -->
    <div class="categories-container">
      <nav class="level">
        <div class="level-left">
          <div class="title-section" id="categorias-defensivas" v-observe-visibility="visibilityChanged">
            <span class="categories-title is-size-4-mobile has-text-centered-mobile">{{
              $t('table.defensive.title')
            }}</span>
          </div>
        </div>
        <div class="level-right">
          <TypeCategoryStats />
          <BField class="is-hidden-mobile" v-if="false">
            <BRadioButton
              v-for="(option, index) in displayOptions"
              v-model="viewData"
              :native-value="option.value"
              :key="index"
              :disabled="option.value === 'pie'"
            >
              <BIcon :icon="option.icon" />
            </BRadioButton>
          </BField>
        </div>
      </nav>
      <!-- Categories Table -->
      <div v-if="viewData === 'table'">
        <DataTable
          :data="translatedTableData"
          :columns="getColumns()"
          :expandedRows="expandedRows"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
        />
        <DataMobileTable
          :data="translatedTableData"
          :columns="getColumns()"
          is-selector-hidden
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
          @openSubcategory="onOpenSubcategory"
          @changeSubcategory="onChangeSubcategory"
        />
      </div>
      <!-- Categories Pie -->
      <div v-else-if="viewData === 'pie'">
        <PieChartsPosessionTeam />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import DataTable from '@/components/Elements/DataTable';
import defensiveDataTable from '@/data/player/defensiveTableData';
import SoccerChalkboard from '@/components/Elements/SoccerChalkboard';
import DataMobileTable from '@/components/Elements/DataMobileTable';
// import TopFiveHorizontalScroll from '@/components/Elements/TopFiveHorizontalScroll';
import SoccerGoal from '@/components/Elements/SoccerGoal';
import playerStatsPlayIndexes from '@/data/player/playerStatsPlayIndexes';
import TypeCategoryStats from '@/components/Elements/TypeCategoryStats';
import { categoriesDisplayOptions } from '@/utils/mixins/categoriesDisplayOptions';
const { columns } = defensiveDataTable;
import { normalPlayer, goalkeeper } from '@/data/player/defensiveChalkboardCategories';
import {
  analisisDeJugadorSeccionVista,
  analisisDeJugadorCategoriasDeTabla,
  analisisDeJugadorTablaGrafica,
  analisisDeJugadorCategoriaDePizarrra,
  analisisDeJugadorSeleccionTodoPizarra,
  analisisDeJugadorVistaPizarra2D3D,
  analisisDeJugadorCategoriaDePorteria,
  analisisDeJugadorDetallesCategoria,
  analisisDeJugadorDetalleSubcategoria,
} from '@/utils/analytics/players';
import translatedTableDataMixin from '@/utils/mixins/translated-table-data';

export default {
  name: 'PlayerDefensive',
  components: {
    // TopFiveHorizontalScroll,
    SoccerGoal,
    SoccerChalkboard,
    DataTable,
    DataMobileTable,
    TypeCategoryStats,
  },
  mixins: [categoriesDisplayOptions, translatedTableDataMixin],
  data() {
    return {
      // columns,
      // expandedRows,
      chalkboardCategories: normalPlayer,
      playerStatsPlayIndexes: playerStatsPlayIndexes(),
    };
  },
  beforeMount() {
    if (this.player.position_id === 1) {
      this.chalkboardCategories = goalkeeper;
    }
  },
  watch: {
    viewData(value) {
      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    getBasePlaysStack: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.setPlaysForGames(newValue);
        }
      },
    },
  },
  computed: {
    showSoccerGoal() {
      return this.player.position_id === 1;
    },
    // ToDo: pending to get updated soccer chalk board to update getters
    ...mapState('teamsOffensive', [
      'categories',
      'featuredPlayers',
      'statistics',
      'data',
      'columnsVisible',
      'expandedColumns',
    ]),
    ...mapGetters('playersGeneral', {
      playsGoal: 'getPlaysGoal',
    }),
    ...mapGetters('playersGeneral', {
      plays: 'getPlays',
      player: 'player',
    }),
    ...mapState(['players', 'teams']),
    ...mapGetters(['availableGames']),
    ...mapGetters('playersGeneral', ['player', 'playerId', 'teamId']),
    ...mapGetters('playersDefensive', [
      'tableData',
      'topFiveCategories',
      'chalkboardPlays',
      'chalkboardGames',
      'goalPlays',
      'getBasePlaysStack',
    ]),
    ...mapGetters('teamsGeneral', {
      seasonTeams: 'teamsForAnalysis',
      team: 'team',
    }),
    ...mapGetters({ seasonId: 'filterGeneral/getSeasonId', section: 'filterGeneral/getCategoryTypeName' }),
    translatedDefensiveCategories() {
      this.chalkboardCategories.forEach(category => {
        category.name = this.$t(category.translationKey);
      });
      return this.chalkboardCategories;
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setPlaysForGames']),
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        const sectionName = entry.target.id;
        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName);
      }
    },
    getColumns() {
      return this.getTranslatedColumns(columns);
    },
    onShowDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'mostrar');
    },
    onHideDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'ocultar');
    },
    onChangePerspectiveSoccerChalkboard(value) {
      analisisDeJugadorVistaPizarra2D3D(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    onChangeSelectAllSoccerChalkboard(value) {
      analisisDeJugadorSeleccionTodoPizarra(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    onChangeCategorySoccerChalkboard(value) {
      analisisDeJugadorCategoriaDePizarrra(
        this.seasonId,
        this.teamId,
        this.playerId,
        this.section,
        value.name,
        value.checked,
      );
    },
    onChangeCategorySoccerGoal(value) {
      analisisDeJugadorCategoriaDePorteria(
        this.seasonId,
        this.teamId,
        this.playerId,
        this.section,
        value.name,
        value.checked,
      );
    },
    onOpenSubcategory(category) {
      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category);
    },
    onChangeSubcategory(subcategory) {
      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory);
    },
  },
};
</script>

<style scoped lang="scss">
/* Top five section */
.top-five-container {
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
}

.top-five-title {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  color: #808285;
  text-transform: uppercase;
}

/* Categories section */
.categories-container {
  margin-top: 20px;
  margin-bottom: 20px;
}

.categories-title {
  font-size: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  color: #808285;
  text-transform: uppercase;
}

.chalkboard-goal {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 16px;

  @media screen and (max-width: 1250px) {
    grid-template-columns: 1fr;
  }
}
</style>
